import React from 'react';
import PageHeader from '../components/PageHeader';
import { useNavigate } from 'react-router-dom';

function FleetAnalytics() {
  const navigate = useNavigate();
  
  return (
    <div className="min-h-screen bg-gray-50">
      <PageHeader 
        title="Fleet Analytics"
        subtitle="Vehicle Usage, Costs & Maintenance"
        backButton
        onBack={() => navigate('/dashboard')}
        backTitle="Back to Dashboard"
      />
      <main className="max-w-full mx-auto px-6 py-8">
        <div className="bg-white rounded-lg shadow p-12 text-center">
          <div className="text-6xl mb-4">🚗</div>
          <h2 className="text-2xl font-bold text-gray-900 mb-2">Fleet Analytics</h2>
          <p className="text-gray-600 mb-4">Vehicle usage, costs, maintenance schedules, and fleet efficiency tracking</p>
          <p className="text-sm text-gray-500">Coming soon - fleet management module</p>
        </div>
      </main>
    </div>
  );
}

export default FleetAnalytics;
